import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 54px;
  padding-left: 28px;
  padding-right: 28px;
  @media (max-width: 600px) {
    padding-top: 16px;
  }
`;

export const Heading = styled.div`
  font-weight: bold;
  font-size: 36px;
  line-height: 43px;
  @media (max-width: 600px) {
    font-size: 28px;
    line-height: 34px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 48px;
  @media (max-width: 600px) {
    margin-top: 0px;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 360px;
  margin: 0 16px;
  padding: 24px;
  margin-top: 24px;
  @media (max-width: 600px) {
    width: 319px;
  }
`;

export const CardImage = styled.div``;

export const CardTitle = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 39px;
  margin-top: 14px;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const CardDescription = styled.div`
  margin-top: 14px;
  text-align: center;
  font-size: 18px;
  line-height: 23px;
  color: #878d96;
  @media (max-width: 600px) {
    margin-top: 8px;
    font-size: 16px;
    line-height: 21px;
  }
`;

export const Icon = styled.img`
  width: 88px;
  height: 88px;
`;
